import script from "./ProductDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProductDialog.vue?vue&type=style&index=0&id=c011bd5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c011bd5c"]])

export default __exports__